// extracted by mini-css-extract-plugin
export var fullWidth = "ButtonGroup-module--fullWidth--13389";
export var grid = "ButtonGroup-module--grid--c1424";
export var pair = "ButtonGroup-module--pair--e82ae";
export var vertical = "ButtonGroup-module--vertical--c64da";
export var wrap = "ButtonGroup-module--wrap--c39d6";